import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  deselectSftpOption,
  isSftpOptionSelected,
  selectSftpOption,
} from "reduxSlices/reportIndexSlice"
import { Checkbox } from "shared/checkboxes"
import { SidebarContentItem } from "shared/Sidebar"

const ReportIndexSidebarSftpSectionSftpCheckbox = ({ label, option }) => {
  const dispatch = useDispatch()

  const optionIsSelected = useSelector(isSftpOptionSelected(option))

  const toggleReducer = optionIsSelected ? deselectSftpOption : selectSftpOption

  const toggleSelection = () => dispatch(toggleReducer({ option }))

  return (
    <SidebarContentItem onClickCapture={toggleSelection}>
      <div className="flex justify-between">
        <span>{label}</span>
        <Checkbox onChange={toggleSelection} value={optionIsSelected} />
      </div>
    </SidebarContentItem>
  )
}

ReportIndexSidebarSftpSectionSftpCheckbox.propTypes = {
  label: types.string.isRequired,
  option: types.string.isRequired,
}

export default ReportIndexSidebarSftpSectionSftpCheckbox
